import React from 'react';
import { Col, Form, Row } from 'reactstrap';
import { ButtonGroup, SelectCustom } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import Pos from '@/model/Pos';
import { FormInputName } from '../../types';

interface StateProps {
  poss: Pos[];
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const RegisterPosContent: React.FC<Props> = ({
  formData,
  poss,
  onChangeFormInput,
  formErrors,
}): JSX.Element => (
  <Form
    noValidate={true}
    onSubmit={(e): void => {
      e.preventDefault();
    }}
  >
    <Row>
      <Col md={8}>
        <SelectCustom
          name="pos"
          label="POS"
          placeholder="Digite ou selecione a POS"
          value={formData[FormInputName.pos]}
          onChange={e => {
            onChangeFormInput(FormInputName.pos)(e?.value as string);
          }}
          options={poss.map(item => ({
            value: item.id,
            label: item.name,
          }))}
          error={formErrors.pos && formErrors.pos[0]}
        />
      </Col>
    </Row>
    <Row>
      <Col lg={8}>
        <ButtonGroup
          label="Aceita desconto?"
          name="allowDiscount"
          value={formData[FormInputName.allowDiscount]}
          onChange={e => onChangeFormInput(FormInputName.allowDiscount)(e.target.value)}
          error={formErrors.allowDiscount && formErrors.allowDiscount[0]}
          options={[
            { value: true, label: 'Sim' },
            { value: false, label: 'Não' },
          ]}
        />
      </Col>
    </Row>
  </Form>
);
